<template>
  <div class="resource-catalog-palette" :aria-label="label + '分类列表'">
    <p v-if="loading" class="editor-component-feedback" role="status">分类加载中…</p>
    <p v-else-if="error" class="editor-component-feedback" role="alert">{{ error }} <button type="button" @click="$emit('retry')">重试分类</button></p>
    <template v-else>
      <p v-if="!sections.length" class="editor-component-feedback" role="status">暂无{{ label }}分类，请先在资源中心添加。</p>
      <section v-for="section in sections" :key="section.key" class="editor-component-section">
        <button type="button" class="editor-component-section__toggle" :aria-expanded="String(isExpanded(section))" :aria-controls="contentId(section)" :aria-label="(isExpanded(section) ? '收起' : '展开') + section.label + '分类'" :title="section.label" @click="toggle(section)">
          <i aria-hidden="true" class="el-icon-arrow-right" :class="{ 'is-expanded': isExpanded(section) }"></i>{{ section.label }}
        </button>
        <div v-if="isExpanded(section) || visited[section.key]" v-show="isExpanded(section)" :id="contentId(section)" class="resource-catalog-palette__content">
          <slot :catalog-id="section.id" :list-key="listKey" />
        </div>
      </section>
    </template>
  </div>
</template>
<script>
export default {
  props: { categories: { type: Array, default: () => [] }, label: String, keyword: { type: String, default: '' }, listKey: String, loading: Boolean, error: String },
  data: () => ({ expanded: {}, searchExpanded: true, visited: {} }),
  computed: {
    sections () {
      if (this.keyword) return [{ key: 'search', id: '', label: '搜索结果' }]
      return this.categories.map(item => ({ key: 'catalog:' + item.id, id: item.id, label: item.label }))
    }
  },
  watch: { listKey () { this.visited = {}; this.searchExpanded = true } },
  methods: {
    contentId (section) { return 'resource-category-' + this._uid + '-' + section.key },
    isExpanded (section) {
      if (section.key === 'search') return this.searchExpanded
      return this.expanded[section.key] === undefined ? section.id === (this.categories[0] ? this.categories[0].id : '') : this.expanded[section.key]
    },
    toggle (section) {
      this.$set(this.visited, section.key, true)
      if (section.key === 'search') this.searchExpanded = !this.searchExpanded
      else this.$set(this.expanded, section.key, !this.isExpanded(section))
    }
  }
}
</script>
<style scoped>
.resource-catalog-palette{flex:1;min-height:0;min-width:0;overflow-y:auto;overscroll-behavior:contain}.resource-catalog-palette__content{min-width:0}.editor-component-section__toggle:focus-visible{outline:2px solid #1677ff;outline-offset:-2px}
</style>
